import React, { useEffect } from "react";
import NumberFormat from "react-number-format";

import LoadMask from "../../../../../../../Utils/LoadMask/LoadMask";
import { NumberField } from "../../../../../../../Utils/renderField/fieldsHookForms";
import { maxFloatNumber } from "../../../../../../../Utils/renderField/hookForms";
import { useFormPesaje } from "../hooks/useFormPesaje";
import Alerta from "../../../../../../../Utils/Alerta/Alerta";
import { usePesajeBascula } from "../../../../../../../Utils/APIs/usePesajeBascula";
import { RenderKilogramo } from "../../../../../../../Utils/renderField/renderReadField";
import { getUltimoPesaje } from "../../../helpers/pesajes";
const refreshIcon = require("assets/img/icons/refresh.png");

export const FormPesaje = (props) => {
    const {
        regresar,
        materiaPrimaSeleccionada,
        configuraciones,
        user,
        trasladoDetalle,
        refrescarPesajeAutomatico,
        onAsignacionPesoSuccess,
    } = props;

    const {
        control,
        formSetValue,
        formGetValues,
        errors,
        pesoNeto,
        AsignarPesoMateriaPrima,
        cargando,
    } = useFormPesaje({
        trasladoDetalle,
        materiaPrimaSeleccionada,
        onAsignacionPesoSuccess,
    });

    const { pesoManual, pesoBascula } = usePesajeBascula({
        configuraciones,
        user,
    });

    useEffect(() => {
        if (!trasladoDetalle) return;

        const pesajes = trasladoDetalle.pesajes || [];

        if (pesajes.length === 0) {
            // primer pesaje
            formSetValue("peso_tara", trasladoDetalle.peso_tara);
        } else {
            // último peso acumulado
            const ultimo = getUltimoPesaje(pesajes);
            formSetValue("peso_tara", ultimo.peso_final);
        }
    }, [trasladoDetalle, formSetValue]);

    useEffect(() => {
        if (!pesoManual) {
            formSetValue("peso_bruto", pesoBascula, {
                shouldValidate: true,
            });
        }
    }, [pesoBascula, pesoManual, formSetValue]);

    return (
        <LoadMask loading={cargando} blur>
            <h3 className="text-center">Pesar materia prima</h3>

            {/* Datos de materia prima */}
            <div className="formulario-fields-row mt-3 text-center">
                <div className="formulario-field">
                    <label htmlFor="acopio_seleccionado" className="m-0">
                        Traslado
                    </label>
                    <span className="d-block mb-1">
                        {trasladoDetalle && trasladoDetalle.numero}
                    </span>
                </div>
                <div className="formulario-field">
                    <label htmlFor="acopio_seleccionado" className="m-0">
                        Materia prima seleccionada
                    </label>
                    <span className="d-block mb-1">
                        {materiaPrimaSeleccionada &&
                            materiaPrimaSeleccionada.materia_prima &&
                            materiaPrimaSeleccionada.materia_prima.nombre}
                    </span>
                </div>
                <div className="formulario-field">
                    <label htmlFor="acopio_seleccionado" className="m-0">
                        Recepciones
                    </label>
                    <span className="d-block mb-1">
                        {materiaPrimaSeleccionada.ingresos_ids_concat}
                    </span>
                </div>
                <div className="formulario-field">
                    <label htmlFor="acopio_seleccionado" className="m-0">
                        Kg húmedos
                    </label>
                    <span className="d-block mb-1">
                        <RenderKilogramo
                            value={materiaPrimaSeleccionada.kilos_humedos}
                            decimalScale={2}
                        />
                    </span>
                </div>
                <div className="formulario-field">
                    <label htmlFor="acopio_seleccionado" className="m-0">
                        Kg secos lab
                    </label>
                    <span className="d-block mb-1">
                        <RenderKilogramo
                            value={
                                materiaPrimaSeleccionada.kilos_secos_laboratorio
                            }
                            decimalScale={3}
                        />
                    </span>
                </div>
            </div>

            <div
                className="d-flex flex-wrap justify-content-center align-items-center mb-3 mt-3"
                style={{ gap: "1rem" }}
            >
                {configuraciones.loader ? (
                    <span>Cargando configuración...</span>
                ) : (
                    <React.Fragment>
                        <Alerta
                            texto={
                                pesoManual
                                    ? `El peso se está tomando manualmente. Para tomarlo de báscula vaya a Configuración.`
                                    : `El peso se está tomando automaticamente de Báscula. Para ingresarlo manualmente se debe ir a Configuración.`
                            }
                            noMarginBottom
                        />
                        <img
                            src={refreshIcon}
                            alt="Refrescar configuración"
                            title="Refrescar configuración"
                            className="action_img"
                            onClick={refrescarPesajeAutomatico}
                        />
                    </React.Fragment>
                )}
            </div>

            {/* Pesos */}
            <div className="formulario-fields-row">
                <div className="formulario-field">
                    <label htmlFor="peso_tara" className="m-0">
                        Peso tara (Sin la materia prima)
                    </label>

                    <div className="d-flex align-items-center">
                        <div className="flex-1">
                            <NumberField
                                control={control}
                                name="peso_tara"
                                errors={errors}
                                allowNegative={false}
                                suffix=" Kg"
                                rules={{
                                    required: "Este campo es obligatorio",
                                    min: {
                                        value: 1,
                                        message: "Debe ser al menos 1",
                                    },
                                    max: {
                                        value: maxFloatNumber,
                                        message: "El número es muy grande",
                                    },
                                }}
                                disabled
                            />
                        </div>
                    </div>
                </div>

                <div className="formulario-field">
                    <label htmlFor="peso_bruto" className="m-0">
                        Peso bruto (Con materia prima)
                    </label>

                    <div className="d-flex align-items-center">
                        <div className="flex-1">
                            <NumberField
                                control={control}
                                name="peso_bruto"
                                errors={errors}
                                allowNegative={false}
                                suffix=" Kg"
                                rules={{
                                    required: "Este campo es obligatorio",
                                    min: {
                                        value: 1,
                                        message: "Debe ser al menos 1",
                                    },
                                    max: {
                                        value: maxFloatNumber,
                                        message: "El número es muy grande",
                                    },
                                    validate: function (value) {
                                        var pesoTara =
                                            Number(
                                                formGetValues("peso_tara"),
                                            ) || 0;
                                        var pesoBruto = Number(value) || 0;

                                        if (pesoBruto <= pesoTara) {
                                            return "El peso bruto debe ser mayor al peso tara";
                                        }

                                        return true;
                                    },
                                }}
                                disabled={!pesoManual}
                            />
                        </div>
                    </div>
                </div>

                <div className="formulario-field">
                    <label>Peso neto de materia prima (calculado)</label>
                    <NumberFormat
                        className="form-control"
                        value={pesoNeto}
                        suffix=" Kg"
                        disabled
                        thousandSeparator=","
                    />
                </div>
            </div>

            <div className="d-flex flex-wrap justify-content-center mt-3 mb-5 gap-1rem">
                <button className="btn btn-outline-dark" onClick={regresar}>
                    Regresar
                </button>
                <button
                    className="btn btn-primary"
                    onClick={AsignarPesoMateriaPrima}
                    disabled={false}
                >
                    Guardar peso de materia prima
                </button>
            </div>
        </LoadMask>
    );
};
